import React, { useState, useEffect, useRef } from 'react'
import api from '../components/api'
import JoditEditor from "jodit-react"
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import { useEmailVerContext } from '../context/emailVerContext'
import moment from 'moment'

const Modal = (props) => {


    const formulario_id = props.formulario_id
    const origem = props.origem
    const adesao_institucional_id = props.adesao_institucional_id
    const ano = props.ano

    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()
    const { desafioEmail_id, setDesafioEmail_id } = useEmailVerContext()

    const [titulo, setTitulo] = useState('')
    const [texto, setTexto] = useState('')
    const [email, setEmail] = useState('')
    const [nomeFantasia, setNomeFantasia] = useState('')
    const [emailGerado, setEmailGerado] = useState(false)
    const [totalErros, setTotalErros] = useState(0)

    const [usuarioEnvio, setUsuarioEnvio] = useState()
    const [assunto, setAssunto] = useState('')
    const [dataHora, setDataHora] = useState('')

    //var [linkRecuperacaoSenha, setLinkRecuperacaoSenha] = useState()
    
    
    //var [autor, setAutor] = useState(sessionStorage.getItem('nome'))
    //var ad_usr = sessionStorage.getItem('us_codigo')


    const editor = useRef(null)
    const [content, setContent] = useState('')


    const [config, setConfig] = useState({
        readonly: true,
        toolbar: true,
        height: 300,
        placeholder: 'Escreva aqui...',
      })




      useEffect(() => {

        //console.log(desafioEmail_id, 'desafioEmail_id')

        if (desafioEmail_id) {

            //console.log(`emailCorrecao/${desafioEmail_id}`)

            api.get(`emailCorrecao/${desafioEmail_id}`).then((result) => {

                console.log(result.data)
                var data = result.data[0]

                setTexto(data.texto)
                setEmail(data.email)
                setUsuarioEnvio(data.usuarioEnvio)
                setAssunto(data.assunto)
                setContent(data.texto)
                setDataHora(data.ad_new)

            }).catch((err) => {

                console.log(err.response)

            })


        }

      }, [desafioEmail_id])


      //console.log(origem)



    return (

        <div>

            <div className="modal fade" id="ModalEmailVer" tabindex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h1 className="modal-title">E-mail</h1>
                        </div>
                        <div class="modal-body">
                                
                                <div className="panel-body">
                                    
                                    
                                <div className="col-md-12">
                                        <div class="form-group">
                                            <label>E-mail</label>
                                            <input type="text" value={email} disabled className="form-control" placeholder="" maxLength={500} />
                                                            
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div class="form-group">
                                            <label>Título/Assunto</label>
                                            <input type="text" value={assunto} disabled className="form-control" placeholder="" maxLength={500} />
                                                            
                                        </div>
                                    </div>

                                    <div className="col-md-8">
                                        <div class="form-group">
                                            <label>Enviado por</label>
                                            <input type="text" value={usuarioEnvio} disabled className="form-control" placeholder="" maxLength={500} />
                                                            
                                        </div>
                                    </div>


                                    <div className="col-md-4">
                                        <div class="form-group">
                                            <label>Em</label>
                                            <input type="text" value={dataHora} disabled className="form-control" placeholder="" maxLength={500} />
                                                            
                                        </div>
                                    </div>


                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <label>Texto</label>
                                                    
                                            <JoditEditor 
                                                ref={editor}
                                                value={content}
                                                config={config}
                                                
                                                tabIndex={1} // tabIndex of textarea
                                                onBlur={newContent => setTexto(newContent)} // preferred to use only this option to update the content for performance reasons
                                                onChange={newContent => {}}
                                            />

                                                            
                                        </div>

                                    </div>


                                    

                                </div>


                        </div>
                        <div className="modal-footer">

                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            
                            
                            
                        </div>
                    </div>
                </div>
            </div>


        </div>

    )

}

export default Modal